export default __webpack_public_path__ + "static/media/vehicle.40f01e7e6df9635998a6d22af6cf0573.svg";